export const EJobHookIntegrationType = {
  "0": "UNKNOWN",
  "1": "ARGUS",
  "2": "NETRESYS",
  "3": "VENTUS",
  "4": "TOUREX",
  "-1": "ALL"
};

export const EJobHookJobType = {
  "0": "UNKNOWN",
  "1": "ENTITY_NEW",
  "2": "ENTITY_CANCEL",
  "3": "ENTITY_CHANGE",
  "4": "ANCILLARY_NEW",
  "5": "ANCILLARY_CANCEL",
  "6": "ANCILLARY_ALL",
  "7": "HOTEL_SEARCH_CACHE_FEED",
  "8": "HOTEL_SPO_CACHE_CLEAN",
  "9": "HOTEL_PROVIDER_ENABLE_GSA_SET",
  "-1": "ALL"
};

export const EJobHookJobStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "RUNNING",
  "3": "DONE",
  "4": "ERROR",
  "-1": "ALL"
};